// src/components/Header.tsx

import React from 'react';
import { Menu, MenuProps } from 'antd';
import { NavLink } from 'react-router-dom';
import {
    FileTextOutlined,
    BarChartOutlined,
    SwapOutlined,
    SettingOutlined,
} from '@ant-design/icons';


interface HeaderProps {}

const getNavLinkClass = ({ isActive }: { isActive: boolean }): string =>
    isActive ? 'text-2xl active' : 'text-2xl';

const Header: React.FC<HeaderProps> = () => {
    // Определяем элементы для левого меню
    const leftMenuItems: MenuProps['items'] = [
        {
            key: 'documents',
            icon: <FileTextOutlined />,
            label: (
                <NavLink className={getNavLinkClass} to="/documents">
                    Документы
                </NavLink>
            ),
        },
        {
            key: 'analytics',
            icon: <BarChartOutlined />,
            label: (
                <NavLink className={getNavLinkClass} to="/analytics">
                    Аналитика
                </NavLink>
            ),
        },
        {
            key: 'comparison',
            icon: <SwapOutlined />,
            label: (
                <NavLink className={getNavLinkClass} to="/comparison/1">
                    Сравнение
                </NavLink>
            ),
        },
    ];

    // Элементы для правого меню
    const rightMenuItems: MenuProps['items'] = [
        {
            key: 'settings',
            icon: <SettingOutlined />,
            label: (
                <NavLink className={getNavLinkClass} to="/settings">
                    Настройки
                </NavLink>
            ),
        },
    ];

    return (
        <div className="sticky top-0 z-50 m-5 rounded-xl shadow-md flex justify-between items-center bg-white">
            <div className="flex justify-center">
                <Menu mode="horizontal" disabledOverflow={true} items={leftMenuItems} />
            </div>
            {/* Для правого меню добавляем класс для смещения */}
            <Menu
                mode="horizontal"
                disabledOverflow={true}
                items={rightMenuItems}
                className="ml-auto"
            />
        </div>
    );
};

export default Header;
